import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "switch-big--sprite",
  "use": "switch-big--sprite-usage",
  "viewBox": "0 0 26 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 14\" id=\"switch-big--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.354.709l11.875 11.875-.707.707L13 1.769 1.479 13.291l-.708-.707L12.647.709 13 .355l.354.354z\" fill=\"#232323\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol